import { Control } from "Controls/Control";
import { DisplayModes, CssClass } from "Enums";
import { ControlTemplate } from "Controls/Entities";
import { CONTROL_ID_ATTRIBUTE_NAME } from "Controls/Control";

/**
 * Control for showing images.
 * @since 4.0.0
 * @example 
 * ```JavaScript
 * // Access the instance of a Image with ControlID 1337
 * // In script:
 * @@ctr:1337@@
 * 
 * // On page:
 * $dms(1337)
 * ```
 */
export class Image extends Control {
    /**
     * @hidden
     */
    protected dmsControlClass: string = "dms-control-image";
    
    /**
     * @hidden
     */
    protected defaultEditorElement = "<img/>";

    protected isBlockElement = false;

    /**
     * Internal method for setElement.
     * @param element JQueryElement for initialization.
     * @hidden
     */
    protected setElementInternal(element: JQuery): void {
    }

    /**
     * Not implemented for this control type.
     * @hidden
     */
    public getValue(): string {
        return null;
    }

    /**
     * Not implemented for this control type.
     * @param value
     * @hidden
     */
    public setValue(value: string) {
    }

    /**
     * Gets template for showing tooltips.
     * @param bindingField Bound field in the datarow.
     * @hidden
     */
    protected getTooltipTemplate(bindingField?: string): string {
        return "";
    }

    /**
     * Internal method for getting the template.
     * @param displayMode DisplayMode for control.
     * @param bindingField Field which the control is bound to.
     * @hidden
     */
    protected getTemplateInternal(displayMode: DisplayModes, bindingField?: string): ControlTemplate {
        let controlTemplate = new ControlTemplate();
        let elem: JQuery;
        if (this.controlDefinition.Icon && this.controlDefinition.Icon.indexOf(".") >= 0) {
            elem = $("<img />");
            elem.attr("src", this.environment.ImagePath + this.controlDefinition.Icon);
        }
        else if (this.controlDefinition.Icon) { // link with font sprite
            elem = $("<span/>");
            let span = $("<span/>");
            span.addClass(this.controlDefinition.Icon);
            elem.append(span);
            elem.addClass("k-button k-button-icon");
        }
        elem.addClass(CssClass.image);
        elem.attr(CONTROL_ID_ATTRIBUTE_NAME, this.controlDefinition.ControlID);
        controlTemplate.template = elem[0].outerHTML;
        controlTemplate.element = elem;
        controlTemplate.editable = false;
        return controlTemplate;
    }

    /**
     * Dispose the control and release all resources.
     * @since 4.0.0
     */
    public dispose(): void {
        super.dispose();
    }
}
